import { Table } from '@mantine/core';

import { NewDialogsRow } from './TableRow';

type NewDialogsTableProps = {
  stats: { page: string; count: number; indicator: string | null }[];
  pageColors: Record<string, { line: string; fill: string }>;
  pagesMap: Record<string, { name: string }>;
};

export const NewDialogsTable = ({ stats, pageColors, pagesMap }: NewDialogsTableProps) => {
  return (
    <Table stickyHeader striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th></Table.Th>
          <Table.Th>Page</Table.Th>
          <Table.Th>Count</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {stats.map(({ page, count, indicator }) => (
          <NewDialogsRow
            key={page}
            page={page}
            count={count}
            indicator={indicator}
            color={pageColors[page]?.line}
            pageName={pagesMap[page]?.name}
          />
        ))}
      </Table.Tbody>
    </Table>
  );
};
